import { useTranslation } from 'react-i18next';
import { Form } from 'react-final-form';

import ModalFormPage from '../../../../../styledComponents/ModalFormPage/ModalFormPage';

import { SmallModal } from '../../../../../styledComponents/ModalCommon/ModalCommon';
import { withErrorProvider } from '../../../../../hoc/withErrorProvider';
import ResendWelcomeEmailForm from '../../../../../styledComponents/Forms/ResendWelcomeEmailForm/ResendWelcomeEmailForm';
import { RESEND_SR_WELCOME_EMAIL_MODAL_NAME } from './resendSRWelcomeEmailModal.const';
import { useResendSRWelcomeEmailModalForm } from './resendSRWelcomeEmailModal.hooks';

type ResendSRWelcomeEmailModalProps = {
  id?: string;
};

const ResendSRWelcomeEmailModal = ({ id }: ResendSRWelcomeEmailModalProps) => {
  const { t } = useTranslation();
  const {
    submitHandler,
    onCancelHandler,
    welcomeEmailResending,
    initState,
    validateForm,
  } = useResendSRWelcomeEmailModalForm({ id });
  return (
    <SmallModal name={RESEND_SR_WELCOME_EMAIL_MODAL_NAME + id}>
      <Form
        keepDirtyOnReinitialize
        onSubmit={submitHandler}
        initialValues={initState}
        validate={validateForm}
      >
        {({ ...renderProps }) => (
          <ModalFormPage
            mode="small"
            handleSubmit={renderProps.handleSubmit}
            onCancel={onCancelHandler}
            title={t('headers.resend-welcome-email')}
            isProcessing={welcomeEmailResending}
          >
            <ResendWelcomeEmailForm disabled={welcomeEmailResending} />
          </ModalFormPage>
        )}
      </Form>
    </SmallModal>
  );
};

export default withErrorProvider(ResendSRWelcomeEmailModal);
